import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initGA, trackPageView } from "./lib/analytics";
import LandingPage from "./pages/LandingPage";
import FounderDashboard from "./pages/FounderDashboard";
import FoundingDesigner from "./pages/FoundingDesigner";
import Insights from "./pages/Insights";
import InsightArticle from "./pages/InsightArticle";
import LandingTemplateRoute, { LandingTemplate } from "./pages/LandingTemplate";
import { LANDING_PAGES } from "./data/landingPages";
import ProductHub from "./pages/ProductHub";
import HowItWorks from "./pages/HowItWorks";
import Pricing from "./pages/Pricing";
import NotFound from "./pages/NotFound";

function RouteTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => { initGA(); }, []);
  // Every route change (any link, anywhere) starts at the top of the new page.
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => {
    // Delay so page-level effects (document.title) run first.
    const t = setTimeout(() => trackPageView(pathname + search), 60);
    return () => clearTimeout(t);
  }, [pathname, search]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <RouteTracker />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/founder" element={<FounderDashboard />} />
        <Route path="/foundingdesigner" element={<FoundingDesigner />} />
        <Route path="/product" element={<ProductHub />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<InsightArticle />} />
        <Route path="/mockup/:lpId" element={<LandingTemplateRoute />} />
        {Object.values(LANDING_PAGES).map((cfg) => (
          <Route
            key={cfg.id}
            path={cfg.route}
            element={<LandingTemplate config={cfg} portalException={cfg.id === 'lp-005'} />}
          />
        ))}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
